
import Vue  from 'vue'

class AxiosErrorMessager extends Vue {
    static instance = null

    messager

    static newInstance() {
        if(this.instance) {
            return this.instance
        }
        this.instance = new AxiosErrorMessager()
        return this.instance
    }

    showMsg(msg, title) {
        this.messager && this.messager.close()
        this.messager = this.$notify({
            title: title || '提示',
            showClose: true,
            message: msg,
            type: 'info',
            center: true
        })
    }

    showErr(msg, title) {
        this.messager && this.messager.close()
        this.messager = this.$notify({
            title: title || '发生错误',
            showClose: true,
            message: msg,
            type: 'error',
            center: true
        })
    }

    processError(errcode, message) {
        let msg = ''
        let tt = ''
        switch(errcode) {
            case 400:
                tt = '请求错误'
                msg = message || '请求参数存在错误'
                break
            case 401:
                tt = '身份认证错误'
                msg = message || '您登录认证已过期，请重新登录'
                break
            case 403:
                tt = '系统拒绝了您的请求'
                msg = message || '您的访问被拒绝了，请登录后再试'
                break
            case 404:
                tt = '请求错误'
                msg = message || '请求地址错误'
                break
            case 408:
                tt = '网络错误'
                msg = message || '请求超时'
                break
            case 500:
                tt = '服务器错误'
                msg = message || '服务器端错误'
                break
            case 501:
                tt = '服务器错误'
                msg = message || '服务器未实现该请求'
                break
            case 502:
                tt = '服务器错误'
                msg = message || '网络连接错误'
                break
            case 503:
                tt = '服务器错误'
                msg = message || '服务不可用'
                break
            case 504:
                tt = '服务器错误'
                msg = message || '网关超时'
                break
            case 505:
                tt = '服务器错误'
                msg = message || 'HTTP请求不支持'
                break
            default:
                msg = message || ('未定义的错误类型：' + errcode)
        }
        this.showErr(msg, tt)
    }

}


const messager = AxiosErrorMessager.newInstance()

export default messager
